import { $Q, $Qll } from "../utils/query-selector";
import api from "../services/api";

const addVipToCart = async (variantId, sellingPlan) => {
  const cartParams = {
    items: [
      {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlan,
      },
    ],
  };

  const response = await api.addToCart(cartParams);

  return response
}

const prepareVipCart = async (variantId, sellingPlan) => {
  //await api.clearCart();
  const vipAdded = await addVipToCart(variantId, sellingPlan);
  const localeHref = window.theme.lang === "fr" ? "/cart" : `/${window.theme.lang}/cart`;

  if (vipAdded) {
    window.location.href = localeHref
  }
}

export const vipCart = async () => {

  const vipButton = $Q("#vipHeadingButton");

  if (vipButton) {

    const variantId = window.vipVariant.vipVariantId
    const sellingPlan = window.vipVariant.vipSellingPlanId

    vipButton.addEventListener("click", (e) => {
      e.preventDefault();
      prepareVipCart(variantId, sellingPlan)
    })
  }

}

const getProductTags = async (handle) => {
  const url = `${window.Shopify.routes.root}products/${handle}.js`;
  const product = await fetch(url)
  .then((response) => response.json())
  .then((data) => data);
  return product.tags
}

export const vipLidocainValidation = async () => {

  const checkoutButtons = $Qll(".cartpage-footer__btn--btn")

  if (checkoutButtons) {

    const url = `${window.Shopify.routes.root}cart.js`;
    const cartContents = await fetch(url)
    .then((response) => response.json())
    .then((data) => data);

    const lineItems = cartContents.items;

    let hasVip = false;
    let hasLidocaine = false;

    await Promise.all(
      lineItems.map(async (item) => {
        if (item.id.toString() === window.vipVariant.vipVariantId) {
          hasVip = true;
        }
        const tags = await getProductTags(item.handle);
        if (tags.some((element) => element.toLowerCase() === "lidocaine")) {
          hasLidocaine = true;
        }
      })
    )

    const errorSections = $Qll(".viplidocaine-error-section")
    if (hasVip && hasLidocaine) {
      checkoutButtons.forEach((button) => {
        button.classList.add("disabled");
      })
      errorSections.forEach((section) => {
        section.classList.remove("hidden");
      })
    } else {
      checkoutButtons.forEach((button) => {
        button.classList.remove("disabled");
      })
      errorSections.forEach((section) => {
        section.classList.add("hidden");
      })
    }
  }
}
